import Breadcrumb, { type Crumb } from './Breadcrumb';

interface PageHeroProps {
  title: string;
  subtitle: string;
  crumbs: Crumb[];
  icon?: string;
}

export default function PageHero({ title, subtitle, crumbs, icon = 'ri-bookmark-3-line' }: PageHeroProps) {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-7 md:px-8 md:py-9">
        <Breadcrumb items={crumbs} />
        <div className="mt-4 flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-2xl text-background-50">
            <i className={icon} />
          </span>
          <div>
            <h1 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">{title}</h1>
            <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>
          </div>
        </div>
      </div>
    </section>
  );
}